import axios from "axios";

import("./assets/styles/main.scss");
import React from "react";
import { render } from "react-dom";
import { BrowserRouter, Switch } from "react-router-dom";
import { Provider } from "mobx-react";
import { rehydrate, hotRehydrate } from "rfx-core";

import { isProducao } from "./config/Constantes";
import "./config/Interceptors";
import App from "./App";
import stores from "./stores";
import Routes from './routes';

require('font-awesome/css/font-awesome.css');
require('bootstrap/dist/css/bootstrap.css');
require('react-datepicker/dist/react-datepicker.css');
require('react-select/dist/react-select.css');
require('react-bootstrap-table/css/react-bootstrap-table.css');

const store = rehydrate();

const routes = new Routes();

const path = window.location.pathname;

if(path === "" || path === "/" || path === "/app" || path === "/app/") {
    window.location.href = '/app/solicitacoes-pendentes';
}

const RenderApp = Component => {
	render(
		<BrowserRouter basename="/app">
			<Provider store={isProducao ? store : hotRehydrate()} routes={routes.data} >
				<Switch>
					<App />
				</Switch>
			</Provider>
		</BrowserRouter>,
		document.getElementById("root")
	);
};

RenderApp(App);

export {store}